export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              Shop by{' '}
              <span className="italic text-primary-500">Category</span>
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md">
            Browse our complete collection of curated pandabuy sheet categories. Every link takes you directly to organized product lists.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          <a
            href="https://kaspreadsheet.com/category-911-Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden sm:col-span-2 lg:col-span-1 lg:row-span-2 min-h-[280px] md:min-h-[360px] flex items-end p-5 md:p-7 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20pair%20of%20trendy%20sneakers%20on%20a%20warm%20cream%20stone%20surface%20with%20soft%20morning%20sunlight%20casting%20gentle%20shadows%20minimalist%20editorial%20fashion%20photography%20clean%20background%20neutral%20earthy%20tones%20high%20detail&width=800&height=1000&seq=cat-shoes-v2&orientation=portrait"
              alt="Shoes category"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Shoes collection"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="relative z-10">
              <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 rounded-full text-xs font-semibold mb-3 whitespace-nowrap">
                Featured
              </span>
              <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                Shoes
              </h3>
              <p className="text-sm text-background-50/75 mt-1">
                Browse curated spreadsheet <i className="ri-arrow-right-up-line ml-1 text-xs"></i>
              </p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-912/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden min-h-[140px] flex items-end p-5 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Folded%20cozy%20hoodies%20and%20sweaters%20in%20neutral%20beige%20and%20cream%20tones%20on%20a%20warm%20wooden%20surface%20with%20soft%20natural%20light%20editorial%20product%20photography%20clean%20minimalist%20composition%20warm%20atmosphere&width=600&height=400&seq=cat-hoodies-v2&orientation=landscape"
              alt="Hoodies Sweaters category"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Hoodies Sweaters"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-lg font-heading font-bold text-background-50">Hoodies / Sweaters</h3>
              <p className="text-xs text-background-50/75 mt-0.5">View collection <i className="ri-arrow-right-up-line ml-1"></i></p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-913/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden min-h-[140px] flex items-end p-5 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Stack%20of%20neatly%20folded%20cotton%20t-shirts%20in%20soft%20pastel%20and%20earth%20tones%20on%20a%20cream%20linen%20surface%20gentle%20afternoon%20light%20editorial%20fashion%20photography%20clean%20minimalist%20aesthetic%20warm%20atmosphere&width=600&height=400&seq=cat-tshirts-v2&orientation=landscape"
              alt="T-Shirts category"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet T-Shirts"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-lg font-heading font-bold text-background-50">T-Shirts</h3>
              <p className="text-xs text-background-50/75 mt-0.5">View collection <i className="ri-arrow-right-up-line ml-1"></i></p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-914/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden min-h-[140px] flex items-end p-5 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20modern%20jackets%20and%20outerwear%20hanging%20on%20a%20minimalist%20wooden%20rack%20in%20a%20bright%20studio%20with%20cream%20walls%20soft%20natural%20lighting%20editorial%20fashion%20photography%20clean%20composition%20warm%20neutral%20tones&width=600&height=400&seq=cat-jackets-v2&orientation=landscape"
              alt="Jackets category"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Jackets"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-lg font-heading font-bold text-background-50">Jackets</h3>
              <p className="text-xs text-background-50/75 mt-0.5">View collection <i className="ri-arrow-right-up-line ml-1"></i></p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-915/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden min-h-[140px] flex items-end p-5 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Tailored%20pants%20and%20casual%20shorts%20displayed%20on%20a%20minimalist%20cream%20surface%20with%20soft%20studio%20lighting%20editorial%20fashion%20photography%20clean%20composition%20warm%20earthy%20tones%20modern%20aesthetic&width=600&height=400&seq=cat-pants-v2&orientation=landscape"
              alt="Pants Shorts category"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Pants Shorts"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-lg font-heading font-bold text-background-50">Pants / Shorts</h3>
              <p className="text-xs text-background-50/75 mt-0.5">View collection <i className="ri-arrow-right-up-line ml-1"></i></p>
            </div>
          </a>

          <a
            href="https://kaspreadsheet.com/search-916/name/Shoes.html"
            target="_blank"
            rel="noopener nofollow"
            className="relative group rounded-2xl overflow-hidden min-h-[140px] flex items-end p-5 cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Collection%20of%20stylish%20caps%20beanies%20and%20hats%20arranged%20on%20a%20warm%20cream%20surface%20soft%20daylight%20from%20side%20window%20editorial%20fashion%20photography%20clean%20minimalist%20composition%20neutral%20earthy%20tones&width=600&height=400&seq=cat-headwear-v2&orientation=landscape"
              alt="Headwear category"
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              title="Pandabuy Sheet Headwear"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/25 to-transparent" />
            <div className="relative z-10">
              <h3 className="text-lg font-heading font-bold text-background-50">Headwear</h3>
              <p className="text-xs text-background-50/75 mt-0.5">View collection <i className="ri-arrow-right-up-line ml-1"></i></p>
            </div>
          </a>

          {[
            { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
            { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-shirt-line' },
            { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-t-shirt-line' },
            { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
            { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-briefcase-line' },
            { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
            { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
            { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
          ].map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-2xl bg-background-100 border border-background-200/60 flex items-center p-4 hover:border-accent-300/50 transition-all duration-300 cursor-pointer min-h-[90px]"
            >
              <div className="flex items-center gap-3 w-full">
                <div className="w-12 h-12 rounded-2xl bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors duration-300">
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-accent-600 text-lg`}></i>
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    View collection <i className="ri-arrow-right-up-line ml-1"></i>
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}